module.exports = __webpack_public_path__ + "static/media/brand04.1584ab81.png";